import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '~common/react/CommonStyles';
import { ContentClickedEventHandler } from '~common/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '~common/telemetryEvents/util/EventHandlerFactories';

import { telemetryConsumerWrapper } from '../../../app/contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '../../../app/contexts/TelemetryContexts';
import { CardViewStyles } from './CardViewStyles';

const baseLinkStyle: React.CSSProperties = {
  fontWeight: 'bold',
  color: CommonStyles.Colors.HyperlinkBlue,
  position: 'relative',
  zIndex: 1 // to ensure it appears above the card's <a> tag
};

const recommendationLinkStyle: React.CSSProperties = {
  color: TabStyles.Colors.F8,
  fontWeight: 'normal',
  position: 'relative'
};

const inactiveLinkStyle: React.CSSProperties = {
  fontWeight: 'bold',
  color: TabStyles.Typography.Color.PrimaryMedium,
};

export interface CardTextAndLinkProps {
  text: string;
  url: string;
  urlDisplayName: string;
  marginLeft?: number;
  isRecommendationType?: boolean;
}

export class CardTextAndLink extends React.PureComponent<CardTextAndLinkProps> {

  public render(): JSX.Element {
    const styleOverrides: React.CSSProperties = {};
    if (this.props.marginLeft) {
      styleOverrides.marginLeft = this.props.marginLeft;
      styleOverrides.maxWidth = CardViewStyles.CardTextAndLinkMaxWidth - this.props.marginLeft;
    }

    const linkStyle: React.CSSProperties = this.props.isRecommendationType ? recommendationLinkStyle : baseLinkStyle;

    const workbookTitleLink = telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
      <a style={linkStyle} href={this.props.url} onClick={this.onLinkClick} onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}>
        {this.props.urlDisplayName}
      </a>
    );

    return (
      <div style={styleOverrides} className={CardViewStyles.CardTextAndLink} title={this.props.text + ' ' + this.props.urlDisplayName}>
        {this.props.text + ' '}
        {this.props.url && workbookTitleLink}
        {!this.props.url &&
          <span style={inactiveLinkStyle}>{this.props.urlDisplayName}</span>
        }
      </div>
    );
  }

  private onLinkClick = (e: React.MouseEvent<HTMLAnchorElement>): boolean => {
    e.stopPropagation();
    return false;
  }
}
